export default __webpack_public_path__ + "static/media/404-dark.4ff51467.svg";